// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import Vuex from 'vuex';
import VueClipboard from 'vue-clipboard2';
import JsonCSV from 'vue-json-csv';
import axios from 'axios';
import VueAxios from 'vue-axios';
import Buefy from 'buefy';
import 'buefy/dist/buefy.css';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import App from './App';
import router from './router';

const apiHost = {
  development: 'http://localhost:8080',
  staging: 'https://api.staging.seniorvu.com',
  production: 'https://api.seniorvu.com',
};

const api = axios.create({
  baseURL: `${apiHost[process.env.NODE_ENV || 'development']}/api`,
});
const auth = axios.create({
  baseURL: `${apiHost[process.env.NODE_ENV || 'development']}/auth`,
});

api.interceptors.request.use((config) => {
  const conf = { ...config };

  conf.headers.Authorization = `Bearer ${localStorage.token}`;

  return conf;
});
// eslint-disable-next-line
api.interceptors.response.use((response) => {
  return response;
}, (error) => {
  if (error.indexOf('status code 403') >= 0) {
    const event = document.createEvent('Event', 'auth', true, true);
    event.initEvent('auth', true, true);
    document.dispatchEvent(event);

    return Promise.resolve(null);
  }

  return Promise.reject(error);
});

VueClipboard.config.autoSetContainer = true;
Vue.use(VueClipboard);
Vue.use(VueAxios, axios);
Vue.use(Vuex);

library.add(fas);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('vue-fontawesome', FontAwesomeIcon);
Vue.component('downloadCsv', JsonCSV);
Vue.use(Buefy, {
  defaultIconComponent: 'vue-fontawesome',
  defaultIconPack: 'fas',
});

Vue.config.productionTip = false;
Vue.config.devtools = true;

Vue.prototype.$api = api;
Vue.prototype.$auth = auth;

const vuexStore = new Vuex.Store({
  state: {
    token: localStorage.getItem('token') || '',
  },
  mutations: {
    SET_TOKEN(state, value) {
      state.token = value;
      localStorage.setItem('token', value || '');
    },
  },
  getters: {
    token(state) {
      return state.token;
    },
  },
  actions: {
    init(store) {
      store.actions.setToken(store, localStorage.getItem('token'));
    },
    setToken(store, value) {
      store.commit('SET_TOKEN', value);
    },
  },
});


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  store: vuexStore,
  template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js